import { useEffect, useRef, useState } from "react";
import {
	GetEditedPartComponent,
	importFiles,
} from "@/components/assets/GetPartComponents";

import {
	INITIAL_HAIR_STYLE,
	INITIAL_BACK_HAIR_STYLE,
	INITIAL_EYEBROWS_STYLE,
	INITIAL_PREVIEW_EYELINE_STYLE,
	INITIAL_EYES_STYLE,
	INITIAL_MOUTH_STYLE,
} from "@/const/initialPartStyle";
import { bodyStore } from "@/store/bodyStore";
import { LoadingStore } from "@/store/loadingStore";
import { BodyPart, PartName } from "@/types/design";
import { partsStore } from "@/store/partsStore";
import { previewPartsStore } from "@/store/previewPartsStore";

type DesignArg = {
	editingBody: any;
	partNames: any;
};

const partNameMapToInitialStyle = {
	hair: INITIAL_HAIR_STYLE,
	backHair: INITIAL_BACK_HAIR_STYLE,
	eyebrows: INITIAL_EYEBROWS_STYLE,
	eyeline: INITIAL_PREVIEW_EYELINE_STYLE,
	eyes: INITIAL_EYES_STYLE,
	mouth: INITIAL_MOUTH_STYLE,
};

const PART_CATEGORIES: PartName[] = [
	"hair",
	"backHair",
	"eyebrows",
	"eyeline",
	"eyes",
	"mouth",
];

export default function useDesign(arg: DesignArg) {
	const { editingBody, partNames } = arg;
	const { setBody, resetBody } = bodyStore();
	const { setParts } = partsStore();
	const { setPreviewParts } = previewPartsStore();
	const { isLoading } = LoadingStore();

	const getPart = (partName: PartName) => {
		const targetPartName = editingBody.data?.[partName];
		const partId = targetPartName?.partId;
		const partStyle =
			targetPartName?.[`${partName}Style`] ??
			partNameMapToInitialStyle[partName];
		const partComponent = partId
			? GetEditedPartComponent(partName, partId)
			: undefined;

		return {
			partName,
			partId: partId,
			partStyle,
			partComponent,
		};
	};

	const isInitialRender = useRef(true);

	useEffect(() => {
		if (isInitialRender.current) {
			if (editingBody) {
				const initialEditBody = [
					getPart("hair"),
					getPart("backHair"),
					getPart("eyebrows"),
					getPart("eyeline"),
					getPart("eyes"),
					getPart("mouth"),
				] as BodyPart[];
				setBody(initialEditBody);
			} else {
				resetBody();
			}
			isInitialRender.current = false;
		}

		PART_CATEGORIES.forEach((partName) => {
			importFiles(partNames[partName], partName, false).then((value) => {
				setParts(partName, value[partName]);
			});
			importFiles(partNames[partName], partName, true).then((value) => {
				setPreviewParts(partName, value[partName]);
			});
		});
	}, []);

	const [showPalette, setShowPalette] = useState<boolean>(false);
	const [showPartMove, setShowPartMove] = useState<boolean>(false);

	return {
		showPalette,
		isLoading,
		setShowPalette,
		setShowPartMove,
		showPartMove,
	};
}
